import numeral from 'numeral';

import { BITCOIN_DECIMAL_PLACES_FORMAT, format } from '@shared/utils/number.utils';
import { TransactionForm } from '../transactionform.model';
import { Range } from '@api/models/bitcoin-rate.model';
import { DEFAULT_DECIMAL_FORMAT } from '../../../../../../shared/utils/number.utils';

export class BitcoinWithdrawalForm extends TransactionForm {
  constructor(customerProducts, paymentOptions) {
    super(customerProducts, paymentOptions);
  }

  static fill(customerProducts, paymentOptions, subTransactions) {
    let form  = new BitcoinDepositForm(customerProducts, paymentOptions);

    // Empty subtransactions before filling cause there is always one default subtransaction when the form is created.
    form.subTransactions = [];

    for (let subTransaction of subTransactions) {
        let subTransactionForm = form.addSubTransaction();

        subTransactionForm.amount = subTransaction.amount.value();
        subTransactionForm.btc = subTransaction.btc.value();
        subTransactionForm.product = subTransaction.customerProduct.id;
    }

    form.props.readOnly = true;
    form.props.isReady = true;

    return form;
  }

  /**
   * @override
   */
  get totalAmount() {
    let totalAmount = numeral(0);

    angular.forEach(this.subTransactions, (subTransaction) => {
        totalAmount.add(subTransaction.amount);
    });

    return totalAmount.format(DEFAULT_DECIMAL_FORMAT);
  }

  get totalBtc() {
    let totalBtc = numeral(0);
    for (let subTransaction of this.subTransactions) {
        totalBtc.add(subTransaction.btc);
    }

    return format(totalBtc, BITCOIN_DECIMAL_PLACES_FORMAT);
  }

  getBtcAdjustedRate(bitcoinRate) {
    return bitcoinRate.computeAdjustedRate(this.totalBtc);
  }

  getBtcAdjustedRateFromTotalAmount(bitcoinRate) {
    return bitcoinRate.computeAdjustedRateFromAmount(this.totalAmount);
  }

  computeAmountConversion(btcAdjustedRate) {
    for (let subTransaction of this.subTransactions) {
        subTransaction.convertBtcToAmount(btcAdjustedRate);
    }
  }

  computeBitcoinConversion(btcAdjustedRate) {
    for (let subTransaction of this.subTransactions) {
        subTransaction.convertAmountToBtc(btcAdjustedRate);
    }
  }

  reset() {
    super.reset();

    this.props.isReady = true;
    this.props.isSubmitting = false;
  }

  /**
   * @override
   */
  toPayload(bitcoinRate) {
    let range = bitcoinRate.getRange(this.totalBtc);

    let payload = {
        transaction: {
            paymentDetails: {
                rateDetails: {
                    rangeStart: Range.formatDecimal(range.start),
                    rangeEnd: Range.formatDecimal(range.end),
                    adjustment: range.getAdjustment(bitcoinRate.latestBaseRate),
                    adjustmentType: range.adjustmentType,
                },
                rate: this.getBtcAdjustedRate(bitcoinRate),
                blockchainRate: bitcoinRate.latestBaseRate.value()
            },
            accountId: this.receiverAddress,
            usingGoogleAuthPassword: this.isUsingGoogleTwoFactor,
            transactionPassword: this.transactionPassword
        }
    };

    let subTransactions = {};

    for (let subTransaction of this.subTransactions) {
        subTransactions[subTransaction.key] = {
            product: subTransaction.product,
            amount: subTransaction.amount,
            forFee: subTransaction.forFee,
            paymentDetails: {
                bitcoin: subTransaction.btc
            }
        };
    }

    payload['transaction']['subTransactions'] = subTransactions;
    payload['transaction']['paymentOption'] = this.paymentOption;
    payload['transaction']['paymentOptionType'] = this.paymentOptionType;
    payload['transaction']['customerFee'] = '0';

    return payload;
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/form/bitcoin/bitcoin-withdrawal-form.model.js